module.exports = __webpack_public_path__ + "img/cp-personal-info.svg";